import { render, staticRenderFns } from "./industryInfo.vue?vue&type=template&id=cae14088&scoped=true"
import script from "./industryInfo.vue?vue&type=script&lang=js"
export * from "./industryInfo.vue?vue&type=script&lang=js"
import style0 from "./industryInfo.vue?vue&type=style&index=0&id=cae14088&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae14088",
  null
  
)

export default component.exports